import { computed, ref } from "vue";
import type { IUseAuthCookiesOptions } from "../types/composables";

export default (opts: IUseAuthCookiesOptions) => {
  const { cookieJWT, cookieKFP, cookieMagnitCode, cookieProfileValid } = opts;

  const cookieJWTRef = ref<
    undefined | null | { access: string; refresh: string }
  >({ access: "", refresh: "" });
  const cookieKFPRef = ref<undefined | null | string>("");
  const cookieMagnitCodeRef = ref<undefined | null | string>("");
  const cookieProfileValidRef = ref<undefined | null | string>("");

  const getKfpTokenCookie = () =>
    (cookieKFP ? cookieKFP.value : cookieKFPRef.value) ?? "";
  const getMagnitCodeCookie = () =>
    (cookieMagnitCode ? cookieMagnitCode.value : cookieMagnitCodeRef.value) ??
    "";
  const getAccessTokenCookie = () =>
    (cookieJWT ? cookieJWT.value?.access : cookieJWTRef.value?.access) ?? "";
  const getRefreshTokenCookie = () =>
    (cookieJWT ? cookieJWT.value?.access : cookieJWTRef.value?.access) ?? "";
  const getProfileValidCookie = () =>
    (cookieProfileValid
      ? cookieProfileValid.value
      : cookieProfileValidRef.value) ?? "";

  const setKfpTokenCookie = (v: string | null) => {
    if (cookieKFP) cookieKFP.value = v;
    else cookieKFPRef.value = v;
  };
  const setMagnitCodeCookie = (v: string | null) => {
    if (cookieMagnitCode) cookieMagnitCode.value = v;
    else cookieMagnitCodeRef.value = v;
  };
  const setJWTToken = (v: { access: string; refresh: string } | null) => {
    if (cookieJWT) cookieJWT.value = v;
    else cookieJWTRef.value = v;
  };
  const setProfileValidCookie = (v: string | null) => {
    if (cookieProfileValid) cookieProfileValid.value = v;
    else cookieProfileValidRef.value = v;
  };

  const removeKfpTokenCookie = () => setKfpTokenCookie(null);
  const removeMagnitCodeCookie = () => setMagnitCodeCookie(null);
  const removeJWTToken = () => {
    setJWTToken(null);
    setProfileValidCookie(null);
  };

  const isAuthorized = computed<boolean>(
    () => !!(cookieJWT ? cookieJWT.value?.access : cookieJWTRef.value?.access),
  );

  if (import.meta.env.DEV && (!cookieJWT || !cookieKFP || !cookieMagnitCode)) {
    console.warn(
      "util-auth/useAuthCookies ИНИЦИАЛИЗИРОВАН ЛОКАЛЬНЫЙ РЕЖИМ. Для нормальной работы модуля рекомендуется предоставить CookieRef от useCookie (https://nuxt.com/docs/api/composables/use-cookie) или подобный аналог, иначе можно ожидать некорректную работу авторизации.",
    );
  }

  return {
    getKfpTokenCookie,
    getMagnitCodeCookie,
    getAccessTokenCookie,
    getRefreshTokenCookie,
    getProfileValidCookie,
    setKfpTokenCookie,
    setMagnitCodeCookie,
    setJWTToken,
    setProfileValidCookie,
    removeKfpTokenCookie,
    removeMagnitCodeCookie,
    removeJWTToken,

    isAuthorized,
  };
};
